import {Directive} from '@angular/core';
import {USER} from '@im-js/token/user';
import {USER_AUTHORIZE_SERVICE, USER_PERMISSION_SERVICE} from '@im-ng/token/user';
import {Identify} from '@js-dot/core';
import {DotCoreService} from '@ng-dot/core';

@Directive()
export abstract class PermitPipeBase {
	protected _authorize: Identify<typeof USER_AUTHORIZE_SERVICE>;
	protected _permission: Identify<typeof USER_PERMISSION_SERVICE>;

	get currentUser() {
		return this._authorize?.currentUser$?.value;
	}

	constructor(_core: DotCoreService) {
		if (_core.includes(USER)) {
			this._authorize  = _core.inject(USER_AUTHORIZE_SERVICE);
			this._permission = _core.inject(USER_PERMISSION_SERVICE);
		}
	}
}

